<!-- Base.FieldError.vue (client-lms) -->
<template>
  <p class="lms_field_error">
    <i class="icon_triangle_alert"></i>
    <slot>{{ message }}</slot>
  </p>
</template>

<script setup lang="ts">
defineProps({
  message: { type: String, default: "" },
});
</script>
